import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ReferralTab } from "./tabs/ReferralTab";
import { Users } from "lucide-react";

interface ReferralModalProps {
  isOpen: boolean;
  onClose: () => void;
  userId: string;
  referralCode: string | null;
  isEvolverFounder?: boolean;
}

export function ReferralModal({
  isOpen,
  onClose,
  userId,
  referralCode,
  isEvolverFounder,
}: ReferralModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-md max-h-[85vh] overflow-y-auto bg-card">
        <DialogHeader>
          <DialogTitle className="font-display text-xl flex items-center gap-2">
            <Users className="w-5 h-5 text-primary" />
            Refer a Friend
          </DialogTitle>
        </DialogHeader>

        <div className="mt-4">
          <ReferralTab
            userId={userId}
            referralCode={referralCode}
            isEvolverFounder={isEvolverFounder}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}